import { Component, OnDestroy, OnInit } from '@angular/core';
import { SimulationTracker } from '../../interfaces/simulation-tracker';
import { SimulationTrackerStatus } from '../../enums/simulation-tracker-status';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Select, Store } from '@ngxs/store';
import { SimulationTrackerState } from 'src/app/state/simulation-tracker/simulation-tracker.state';
import { Observable, Subject, switchMap, takeUntil, tap } from 'rxjs';
import {
  PredictorModelState,
  SelectedStudyAreaModel,
} from 'src/app/state/predictor-model/predictor-model.state';
import { SimulationTrackerActions } from 'src/app/state/simulation-tracker/simulation-tracker.actions';
import { SimulationTrackerDataService } from '../../services/simulation-tracker-data.service';

@Component({
  selector: 'app-background-simulation-details-overlay',
  templateUrl: './background-simulation-details-overlay.component.html',
  styleUrl: './background-simulation-details-overlay.component.scss',
})
export class BackgroundSimulationDetailsOverlayComponent
  implements OnInit, OnDestroy
{
  @Select(PredictorModelState.selectedStudyAreaData)
  selectedStudyAreaData$!: Observable<SelectedStudyAreaModel>;

  simulationTrackers: SimulationTracker[] = [];

  readonly statusMap: Record<SimulationTrackerStatus, string> = SimulationTrackerDataService.MinifiedTrackerStatusMap;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit() {
    this.selectedStudyAreaData$
      .pipe(
        tap(() => {
          this.store.dispatch(
            new SimulationTrackerActions.RemoveCompletedSimulationTrackersFromSession()
          );
        }),
        switchMap((selectedStudyArea: SelectedStudyAreaModel) =>
          this.store.select(
            SimulationTrackerState.getSessionSimulationTrackersByStudyArea(
              selectedStudyArea?.id
            )
          )
        ),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((simulationTrackers: SimulationTracker[]) => {
        this.simulationTrackers = simulationTrackers;
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  isSuccessful(simulationTracker: SimulationTracker): boolean {
    return SimulationTrackerDataService.IsSuccessful(simulationTracker.status!);
  }

  isFailed(simulationTracker: SimulationTracker): boolean {
    return SimulationTrackerDataService.IsFailed(simulationTracker.status!);
  }

  isInProgress(simulationTracker: SimulationTracker): boolean {
    return SimulationTrackerDataService.IsInProgress(simulationTracker.status!);
  }

  willEmailResults(simulationTracker: SimulationTracker): boolean {
     return !simulationTracker.scenarioId && !SimulationTrackerDataService.IsDone(simulationTracker.status!)
  }

  getName(simulationTracker: SimulationTracker): string {
    if(simulationTracker.scenarioId) {
      return `Scenario ${simulationTracker.scenario}`;
    } else {
      return simulationTracker.studyAreaName ?? '';
    }
  }



  getStatusColorClass(simulationTracker: SimulationTracker): string {
    return SimulationTrackerDataService.MinifiedTrackerStatusColorMap[
      simulationTracker.status!
    ];
  }

   viewSimulationResultsWithoutDilogBox(simulationTracker: SimulationTracker): void {
    this.viewSimulationResults(simulationTracker);
   }


  openConfirmationDialog(simulationTracker: SimulationTracker): void {
    this.confirmationService.confirm({
      header: 'Confirmation',
      message:
        'View Results will navigate away from the current visualized simulation. This will cancel the current simulation and you will not be able to visualize it still running.',
      acceptButtonStyleClass: 'p-button-text p-ml-5',
      acceptIcon: 'none',
      acceptLabel: 'Proceed',
      rejectButtonStyleClass: 'p-button-text',
      rejectIcon: 'none',
      rejectLabel: 'Cancel',
      accept: () => {
        this.viewSimulationResults(simulationTracker);
      },
      reject: () => {
        return;
      },
    });
  }

  
viewSimulationResults(simulationTracker: SimulationTracker): void {
  const simulationId = simulationTracker.simulationTrackerId ?? 'no-simulation-id';
  const url = this.router.serializeUrl(
    this.router.createUrlTree(['simulation-results', simulationId], {
      relativeTo: this.route,
    })
  );

  const fullUrl = `${window.location.origin}${url}`;
  window.open(fullUrl, '_blank');
  }

}

